import { render, staticRenderFns } from "./MultiTextEditor.vue?vue&type=template&id=2afa2936&scoped=true&"
import script from "./MultiTextEditor.vue?vue&type=script&lang=js&"
export * from "./MultiTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./MultiTextEditor.vue?vue&type=style&index=0&id=2afa2936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa2936",
  null
  
)

export default component.exports